import React, { useEffect, useState } from "react";
import { Table } from "antd"; // Import Ant Design Table
import TitleComp from "../components/Title/title";
import DrawerComp from "../components/Drower/Drawer";
import axios from "axios";

export default function UserDetail() {
  const columns = [
    {
      title: "User Id",
      dataIndex: "user_id",
      key: "user_id",
    },
    {
      title: "User Name",
      dataIndex: "user_name",
      key: "user_name",
    },
    {
      title: "User Email",
      dataIndex: "user_email",
      key: "user_email",
    },
    {
      title: "User Phone",
      dataIndex: "user_phone",
      key: "user_phone",
    },
  ];

  const [fetchList, setFetchList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalData, setTotalData] = useState(0);

  const adminToken = "OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH";
  
  const fetchData = async (page, limit) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://skdm.in/server/onefiveapi/user.php?action=fetch&admin_token=OdRLLsX46k3L8EwZgpNlVK5tKiRaghecPNH&limit=${limit}&page=${page}&out_stock=1`
      );

      if (response.data && response.data.list) {
        setFetchList(response.data.list);
        setTotalData(response.data.total || response.data.list.length);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error making GET request", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage, pageSize);
  }, [currentPage, pageSize]);

  return (
    <div>
      <TitleComp name="Users Lists" totalData={totalData} type="Users" />
      <Table
        columns={columns}
        dataSource={fetchList}
        loading={loading}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalData,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            setCurrentPage(page);
            setPageSize(pageSize);
          },
        }}
        rowKey="user_id"
      />
      <DrawerComp />
    </div>
  );
}
